import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.data-view.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/web.timers.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import OverlayLoading from '~/core/components/OverlayLoading/OverlayLoading.vue';
import { usePending } from '~/core/composables';
import { parseFileToDataUrl } from '~/core/functions';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import { MedcardApi } from '~/features/Medcard/api/medcard.api';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAiProcessing',
  props: {
    image: null
  },
  emits: ["apply"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    _useCssVars(function (_vm, _setup) {
      return {
        "3032451a": _setup.overlayTransitionDurationCss
      };
    });
    var RESPONSE_MIME_TYPE = 'image/jpeg';
    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException;
    var $snackbar = useMainSnackbarStore();
    var overlayTransitionDuration = 300;
    var overlayTransitionDurationCss = "".concat(overlayTransitionDuration, "ms");
    var isOverlayFadingOut = ref(false);
    var isProcessingWithDelay = ref(false);
    var isProcessSwitchEnabled = ref(false);
    var processedImageDataUrl = ref();
    var processedImage = ref();
    var originalImageDataUrl = ref();
    var _usePending = usePending(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var imageBase64, blobData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!processedImage.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isOverlayFadingOut.value = false;
              _context.prev = 3;
              _context.next = 6;
              return parseFileToDataUrl(props.image);
            case 6:
              originalImageDataUrl.value = _context.sent;
              _context.next = 9;
              return MedcardApi.normalizeDocument(originalImageDataUrl.value.split(',')[1]);
            case 9:
              imageBase64 = _context.sent.data.image;
              processedImageDataUrl.value = "data:".concat(RESPONSE_MIME_TYPE, ";base64,").concat(imageBase64);
              blobData = new Uint8Array(_toConsumableArray(atob(imageBase64)).map(function (char) {
                return char.charCodeAt(0);
              }));
              processedImage.value = new File([new Blob([blobData], {
                type: RESPONSE_MIME_TYPE
              })], 'processed-image', {
                type: RESPONSE_MIME_TYPE
              });
              isProcessSwitchEnabled.value = true;
              _context.next = 21;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              isProcessSwitchEnabled.value = false;
              $captureException(_context.t0);
              $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
            case 21:
              _context.prev = 21;
              isOverlayFadingOut.value = true;
              return _context.finish(21);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 16, 21, 24]]);
      }))),
      isProcessing = _usePending.pending,
      refresh = _usePending.refresh;
    watch(isProcessing, function () {
      if (!isProcessing.value) {
        setTimeout(function () {
          isProcessingWithDelay.value = false;
        }, overlayTransitionDuration);
      } else {
        isProcessingWithDelay.value = true;
      }
    });
    function handleInputSwitch(value) {
      if (value && !processedImage.value) {
        refresh();
      }
    }
    function handleClickApply() {
      if (processedImage.value && isProcessSwitchEnabled.value) {
        emit('apply', processedImage.value);
        return;
      }
      emit('apply', props.image);
    }
    return {
      __sfc: true,
      RESPONSE_MIME_TYPE: RESPONSE_MIME_TYPE,
      props: props,
      emit: emit,
      $captureException: $captureException,
      $snackbar: $snackbar,
      overlayTransitionDuration: overlayTransitionDuration,
      overlayTransitionDurationCss: overlayTransitionDurationCss,
      isOverlayFadingOut: isOverlayFadingOut,
      isProcessingWithDelay: isProcessingWithDelay,
      isProcessSwitchEnabled: isProcessSwitchEnabled,
      processedImageDataUrl: processedImageDataUrl,
      processedImage: processedImage,
      originalImageDataUrl: originalImageDataUrl,
      isProcessing: isProcessing,
      refresh: refresh,
      handleInputSwitch: handleInputSwitch,
      handleClickApply: handleClickApply,
      OverlayLoading: OverlayLoading
    };
  }
});